import { call } from "redux-saga/effects";
import { API_URL } from "../_config";
import { CallApi } from "./api/callApi";

export function* openConversation(action: any): any {
  try {
    const data = action.payload || {};
    const resp = yield call(CallApi.POST, API_URL.CHAT.OPEN_CONVERSATION, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* listConversations(action: any): any {
  try {
    const { params = {} } = action.payload || {};
    const resp = yield call(CallApi.GET, API_URL.CHAT.LIST_CONVERSATIONS, params, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getMessages(action: any): any {
  try {
    const { conversationId, params = {} } = action.payload || {};
    const url = API_URL.CHAT.GET_MESSAGES(conversationId);
    const resp = yield call(CallApi.GET, url, params, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* sendMessage(action: any): any {
  try {
    const { conversationId, file, message_text } = action.payload || {};
    const url = API_URL.CHAT.SEND_MESSAGE(conversationId);

    let data: any = { message_text };

    // If file exists, upload to S3 first via pre-signed URL
    if (file) {
      try {
        // Step 1: Get pre-signed upload URL from API
        const uploadUrlResp = yield call(CallApi.POST, API_URL.CHAT.GENERATE_UPLOAD_URL, {
          filename: file.name,
          size: file.size,
          mime_type: file.type,
        }, true);

        if (uploadUrlResp.status >= 200 && uploadUrlResp.status < 300 && uploadUrlResp.data?.data) {
          const { upload_url, s3_key } = uploadUrlResp.data.data;

          // Step 2: Upload file directly to S3 using PUT request
          const uploadResp = yield call(fetch, upload_url, {
            method: 'PUT',
            body: file,
            headers: {
              'Content-Type': file.type,
            },
          });

          if (!uploadResp.ok) {
            throw new Error('Failed to upload file to S3');
          }

          // Step 3: Add S3 path to message data (not FormData, just JSON)
          data.attachment_path = s3_key;
          data.attachment_name = file.name;
          data.attachment_type = file.type;
        } else {
          throw new Error('Failed to get upload URL');
        }
      } catch (uploadError: any) {
        action && action.callbackError && action.callbackError({ message: uploadError.message || 'File upload failed' });
        return;
      }
    }

    // Send message with S3 path (or just text) as JSON
    const resp = yield call(CallApi.POST, url, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* markAsRead(action: any): any {
  try {
    const { conversationId } = action.payload || {};
    const url = API_URL.CHAT.MARK_READ(conversationId);
    const resp = yield call(CallApi.POST, url, {}, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* blockJobseeker(action: any): any {
  try {
    const { conversationId } = action.payload || {};
    const url = API_URL.CHAT.BLOCK(conversationId);
    const resp = yield call(CallApi.POST, url, {}, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getUnreadCount(action: any): any {
  try {
    const resp = yield call(CallApi.GET, API_URL.CHAT.UNREAD_COUNT, {}, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}
